import ClientResponseProps from 'common/types/UserResponseProps';
import { useState } from 'react';
import sendFetch from 'common/utils/fetch';

export const useFetchClients = (searchValue: string, companyId: string) => {
  const [clientList, setClientList] = useState<ClientResponseProps[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchClients = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append('companyId', companyId);
    formData.append('param', searchValue || '');
    try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = await sendFetch('https://api-workspace.astin.net/api/user/find-user', {
        method: 'POST',
        data: formData,
      });
      if (response[0] === 200 && response[1]?.status === 'Ok') {
        setClientList(response[1].users);
      } else {
        setError(response[1]?.message || 'Помилка завантаження даних');
      }
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };
  return { clientList, loading, error, fetchClients };
};
